import type { ReactNode } from "react";
import { usePunditUserContext } from "@circle-react/contexts";

export const BlockInViewOnlyMode = ({ children }: { children: ReactNode }) => {
  const { isViewOnlyMasquerading } = usePunditUserContext();

  if (isViewOnlyMasquerading) {
    return (
      <div className="!cursor-not-allowed">
        <div className="!pointer-events-none">{children}</div>
      </div>
    );
  }

  return <>{children}</>;
};
